(()=>{
 if(document.documentElement.dataset.noeCardGalleryReady)return;
 document.documentElement.dataset.noeCardGalleryReady='true';
 const changeImage=button=>{
  const gallery=button.closest('[data-noe-card-gallery]'),media=gallery?.closest('.nr-card-media'),image=media?.querySelector('.nr-card-image img');
  if(!gallery||!image)return;
  let urls=[];try{urls=JSON.parse(gallery.querySelector('[data-noe-card-images]')?.textContent||'[]')}catch(error){return}
  if(urls.length<2)return;
  const index=(Number(gallery.dataset.index||0)+Number(button.dataset.noeImageStep)+urls.length)%urls.length;
  gallery.dataset.index=String(index);image.removeAttribute('srcset');image.src=urls[index];
 };
 // The rails own drag and auto-scroll gestures. Resolve gallery arrows first in the
 // document capture phase so a rail cannot consume their click or redirect to a card.
 window.noeCardGalleryChange=changeImage;
 window.noeCardGalleryBind=root=>root.querySelectorAll?.('[data-noe-image-step]').forEach(button=>button.dataset.noeGalleryBound='true');
 window.noeCardGalleryBind(document);
 const consume=event=>{event.preventDefault();event.stopImmediatePropagation();};
 // Switch at press time. This makes the new image paint while the pointer is still
 // over the arrow, rather than waiting for a card rail's release/drag lifecycle.
 document.addEventListener('pointerdown',event=>{
  const button=event.target.closest?.('[data-noe-image-step]');
  if(!button)return;
  consume(event);changeImage(button);button.dataset.noeGalleryPressed='true';
  setTimeout(()=>delete button.dataset.noeGalleryPressed,800);
 },true);
 document.addEventListener('click',event=>{
  const button=event.target.closest?.('[data-noe-image-step]');
  if(!button)return;
  consume(event);
  if(button.dataset.noeGalleryPressed){delete button.dataset.noeGalleryPressed;return;}
  changeImage(button);
 },true);
})();
